import { inject } from '@angular/core';
import { createEffect } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { distinctUntilChanged, filter, map } from 'rxjs';
import { RootState } from '../../root-store/root.state';
import { SeSideComponentType } from '../se-side-components/se-side-components-models';
import { sideTabClicked } from './se-side-nav.actions';
import { selectHasPatientHistory } from './se-side-nav.selectors';

export class SeSideNavEffects {
    private store = inject(Store<RootState>);

    /**
     * Effetto che forza il set del tab `reportHistory` quando
     * è presente tra i componenti attivi.
     */
    setReportTabWhenHasHistory$ = createEffect(() =>
        this.store.select(selectHasPatientHistory).pipe(
            distinctUntilChanged(),
            filter((hasReport) => hasReport === true),
            map(() =>
                sideTabClicked({
                    componentType: SeSideComponentType.reportHistory,
                })
            )
        )
    );
}
